<div class="issue-container">
  <app-userlist [avatars]="avatars"></app-userlist>
  <div class="main userstorycard" [attr.data-issueid]="this.issue.id" [ngClass]="{
    'parent-issue': (!issue.isSubissue),
    'sub-issue':(issue.isSubissue),
    'issue-status--done': (this.issue.status.statusCategory.key === 'done'),
    'issue-type--epic': (this.inheritedIssueType === 0),
    'issue-type--story': (this.inheritedIssueType === 1),
    'issue-type--task': (this.inheritedIssueType === 2),
    'issue-type--bug': (this.inheritedIssueType === 3)
  }" (click)="handleIssueClicked($event, this.issue)">

    <app-unseen-indicator [issue]="issue"></app-unseen-indicator>

    <!-- issue-type indicator  -->
    <div class="issue-type-indicator" [ngClass]="{
      'issue-type-indicator--epic': (this.inheritedIssueType === 0),
      'issue-type-indicator--story': (this.inheritedIssueType === 1),
      'issue-type-indicator--task': (this.inheritedIssueType === 2),
      'issue-type-indicator--bug': (this.inheritedIssueType === 3)
    }">
    </div>

    <div class="content-container">
      <div class="card-content">
        <!-- summary -->
        <div class="cardtext">{{issue.summary || ('components.issuecard.titlePlaceholder' | translate)}}</div>
        <!-- avatar -->
        <div class="avatars">
          <div class="avatar" *ngIf="!issue.isSubissue && issue.storyPoints">
            <div class="avatar__content avatar__content--text">{{issue.storyPoints}}</div>
          </div>
          <div class="avatar">
            <img class="avatar__content" *ngIf="issue.assignee"
                 [src]="'data:image/png;base64,'+ this.issue.assignee.avatarImage">
            <i class="avatar__content material-icons icon__placeholder" *ngIf="!issue.assignee">person</i>
          </div>
        </div>
      </div>
      <app-last-updated [issue]="issue" [isCardView]="true"></app-last-updated>
    </div>
  </div>
</div>
